export const course_number = 'CMSC839E'
export const course_full_name = 'Advanced Topics in Human-Computer Interaction (Fall 2025)'
export const course_sub_name = 'Uncertainty Communication for Decision-making '
export const course_short_name = 'uncertainty'
export const course_time = 'MW 2:00pm - 3:15pm'

export const course_objective_long = `
<p>
<b>Description</b>&#8212;This course covers Human-Computer Interaction (HCI) research topics focusing on model uncertainty and decision-making. We will cover a range of models, from linear regression to probabilistic forecasts and AI foundation models, and explore how to help human users understand and manage uncertainty in these computational models. Core topics include

<font class='topic'>statistical communication</font>, 
<font class='topic'>explainability</font>, 
<font class='topic'>decision-making</font>, 
<font class='topic'>uncertainty visualization</font>, and 
<font class='topic'>LLM uncertainty</font>.

 This course is <b>MS/PhD qualifying</b> in Software Engineering/Programming Languages/HCI.  The class format includes a combination of presentations, discussions, and lectures. 
 

</p>

<p>
<b>Course objectives</b>&#8212;Students who take this course should have an interest in HCI and/or uncertainty communication. Prior experience with HCI or Visualization courses is beneficial but not required. Assignments are designed to learn project management skills and to provide practical experience for peer-reviewing.

By the end of this course, students should be able to 
<ul>
<li>Describe the background and open problems within the covered topics. </li>
<li>Propose new research projects based on the learned topics. </li>
<li>Choose and justify appropriate HCI research methods for their projects. </li>
<li>Understand the peer-reviewing process in HCI. </li>
<li>Improve their communication and presentation skills. </li>
</ul>

</p>
`



export const course_location = `IRB 1207`

export const syllabus_intro = `
                Most materials will be released publicly on this website. Confidential content (like reviews and signups) will be released on a UMD google drive. <br/>
                We reserve the right to change the syllabus, assignments, and policies as needed throughout the semester. Major changes will be announced in class and via email. 
`


export const howitworks = `We combine conventional activities (presentations, discussions, projects) with experimental ones (peer-reviewing). Slack will be used for class communication and finding collaborators. Unless specified otherwise, submit assignments through Canvas. Course materials will also be synced on Canvas.`


export const assignments = [
    {
        'name': 'Class presentations',
        'summary': '',
        'divs': [
            {
                'perc': .08,
                'id': 'paper-presentation',
                'requirement': `In each class, students will present papers from the provided paper list. 
                                `,
                'long_requirement': `
                Each presentation should last 8-15 minutes. <br/>
                Please sign up for 1 paper over the course of the semester. I will frozen the signup on Monday for next week. <br/>
                You can choose to present an optional paper if your co-presenter(s) agree. <br/>
                Presenters in the same class are encouraged to coordinate and decide how they would like to present and lead the discussion. <br/>
                You may reuse any online materials (e.g., slides, videos, demos) as long as you adhere to their licenses and describe the materials in your own words. <br/>
                You may use any online resources as guidance, but make sure to at least introduce the problem, present some methods and results, and stimulate a discussion.  
                `
            },
            {
                'perc': .05,
                'id': 'role-presentation',
                'requirement': `Play other roles (except for main presenter) at least twice throughout the semester.
                                `,
                'long_requirement': `
                 Each role presents 3-5 minutes. <br/>
                `
            },
            {
                'perc': .05,
                'id': 'project-presentation',
                'requirement': `Your (group) presentation of your project + Q&A. `,
                'long_requirement': `
                 Depending on the number of papers, the presentation could range from 6 to 15 minutes, while the Q&A and feedback session could range from 3 to 10 minutes.
                `
            }
            ,
            {
                'perc': .05,
                'id': 'course-attendance',
                'requirement': `Course attendance and participation `,
                'long_requirement': `
                Course attendance is important for your experience and the experience of your peers. We expect you to attend most of the classes. Take a photo of your attendance and submit it on Canvas. <br/>
                `
            }
        ]
    },

    {
        'name': 'Weekly reading responses',
        'summary': '',
        'divs': [
            {
                'perc': .15,
                'id': 'reading-responses',
                'requirement': 'Submit 1-2 questions for each required paper before the day of the class (AoE = 8AM on class day).  ',
                'long_requirement': `
                You can substitute a required paper with an optional paper, although we encourage you to read the required papers. <br/>
                At least some questions per week should be non-trivial. While we won't strictly count non-trivial questions every week, your questions should show that you are consistently reading and critically thinking about the papers.  <br/>
                You may read papers in advance to help write your proposal. In this case, your questions will still be counted, even if those papers are later removed. (This is a git-tracked website.)`
            }]
    },

    {
        'name': 'Assignment 1:',
        'summary': '<a href="https://docs.google.com/document/d/15Cfz0HHoQT9XNmW13Qy48uV8VmAYs8p2yLfrhMbHFNI/edit?usp=sharing">Project, proposal, & paper</a>',
        'divs': [
            {
                'perc': .05,
                'id': 'project-plan',
                'requirement': 'P.1 project proposal (group) ',
                'long_requirement': `Submit a 1-2 page proposal outlining the research question(s) you will pursue, possible methods, anticipated results, and a timeline.`
            },
            {
                'perc': .01,
                'id': 'abstract-author',
                'requirement': 'P.2 abstract & author information (group; not submitting on time will result in a 0 of P.3)  ',
                'long_requirement': `Submit your paper title, co-authors, and an abstract (100 to 400 words).`
            },
            {
                'perc': .15,
                'id': 'paper-submission',
                'requirement': 'P.3 paper submission (group; no late submissions accepted) ',
                'long_requirement': `Submit a 2-3 page paper that outlines your research problem, related work, methods, preliminary results, and future work.`
            }
        ]
    },

    {
        'name': 'Assignment 2:  ',
        'summary': '<a href="https://docs.google.com/document/d/1iGmMkk73cQQ2C3GfaNVcU9f8Mkx_1tjIXMVvdp1qHC0/edit?usp=sharing">Peer review</a> (draft)',
        'divs': [
            {
                'perc': .01,
                'id': 'bidding',
                'requirement': 'R.1 Bidding & conflict (solo) ',
                'long_requirement': `Indicate in a spreadsheet the papers you'd like to review and those you should not review due to conflicts of interest.  <
                 We have a script to match interests and assign reviews automatically.`
            },
            {
                'perc': .1,
                'id': 'peer-reviews',
                'requirement': 'R.2 Write one peer review (solo) ',
                'long_requirement': `Students need to submit 1 peer review. <br/>
                 We will briefly review the submissions to ensure they are appropriate.
                `
            },
        //   { 'perc': .10,
        //         'id': 'final',
        //         'requirement': '<a href=\'https://docs.google.com/document/d/1MOivtgkwJyjpv1Z-ElEC1mC1jJKZO3AHngmAxk9ONL0/edit?usp=sharing\'>R.3</a> the final revised short paper and revision report (group; no late submissions accepted) ',
        //         'long_requirement': `
        //         The teaching staff will look at the revised papers, the reviews, and your responses, and will then decide on a score. <br/>

        //         This exam will be graded based on the quality of the revised version and if I can follow your revision report to identify what you have changed. If you receive a particularly picky review, you only need to respond to it reasonably.
        //          `
        //   }
                ]
    },
    {
        'name': 'Midterm exam & Final exam',
        'summary': '(take-home)',
        'divs': [
            {
                'perc': .15,
                'id': 'midterm',
                'requirement': ' <b>[midterm]</b> ~15 questions from those discussed in class prior to the exam. You select 7 to answer and submit a PDF to Canvas. (solo) ',
                'long_requirement': `
                 Expect to write 1-3 paragraphs for each question. We grade based on your idea, but be sure to read your answers for obvious readability issues. <br/>
                 We will generate answers with GPT & Claude to check if your answers are too similar to the generated answers. <br/>
                 `
            },
            {
                'perc': .15,
                'id': 'final-exam',
                'requirement': ' <b>[final exam]</b> the revised short paper and revision report (group; no late submissions accepted) ',
                'long_requirement': `
                     The teaching staff will look at the revised papers, the reviews, and your responses, and will then decide on a score. <br/>
                     This exam will be graded based on the quality of the revised version and if we can follow your revision report to identify what you have changed. 
                     If you receive a particularly picky review, you only need to respond to it reasonably.
   
                 `
            }]
    }
    ,
    {
        'name': 'Extra credit',
        'summary': '   ',
        'divs': [
            {
                'perc': .10,
                'id': 'extra-credit',
                'requirement': 'Exceptional presentation, paper, or participation could earn up to 10% extra credit.'
            }]
    }
]




export const syllabus = `| Week <br/>| Date | Topics | Reading (due 7AM on class day) | Assignments |

|-|---|-----------------|------------------------------|--------|

| 1    | 09/03/25 |   Introduction     |      Fumeng presents <a href='/CMSC839E-2025/slides/w0-logistics.pdf' target='_blank'>[slides]</a>                |     |

| 2    | 09/08/25 |   Icebreaking    |       Bring a Chart You Like: <a href="https://docs.google.com/document/d/1e6KDMG0Jqz_LUzHqtjyndXxABCxFkzkefSWIYjwAH1o/edit?usp=sharing"> Chart Gallery I </a> (use your UMD email)                |       |

|      | 09/10/25 |   Icebreaking    |       Bring a Chart You Don't Like: <a href="https://docs.google.com/document/d/1TKvaAHj07XdJ4eM_Gs6MGjWf5-ZUB2eBXuLIVMokVJs/edit?usp=sharing"> Chart Gallery II </a> (use your UMD email)                   |       |

| 3    | 09/15/25 |   AI & Bias - Model |
[##X] Cognitive Bias in Decision-Making with LLMs [[link]](https://aclanthology.org/2024.findings-emnlp.739.pdf)
[##X] AI Can Be Cognitively Biased: An Exploratory Study on Threshold Priming in LLM-Based Batch Relevance Assessment [[link]](https://arxiv.org/pdf/2409.16022)
<font class='paper-index-title'> Optional: </font>    
[##O] How Cognitive Biases Affect XAI-Assisted Decision-Making: A Systematic Review  [[link]](https://dl.acm.org/doi/pdf/10.1145/3514094.3534164)
                  |   all out    |

|      | 09/17/25 |      AI & Bias - Human |
 [##X] Lessons for Artificial Intelligence from the Study of Natural Stupidity [[link]](https://www.nature.com/articles/s42256-019-0038-z)
 [##X] Deciding Fast and Slow: The Role of Cognitive Biases in AI-Assisted Decision-Making [[link]](https://dl.acm.org/doi/pdf/10.1145/3512930)
                      |       |

| 4    | 09/22/25 |    LLM & Uncertainty   |        
[##X] From Calibration to Collaboration: LLM Uncertainty Quantification Should Be More Human-Centered [[link]](https://arxiv.org/pdf/2506.07461)
[##X] "I'm Not Sure, But...": Examining the Impact of Large Language Models' Uncertainty Expression on User Reliance and Trust [[link]](https://dl.acm.org/doi/pdf/10.1145/3630106.3658941?utm_source=newsletter&utm_medium=email&utm_campaign=newsletter_axioslogin&stream=top)
                |       |

|      | 09/24/25 |   Misinformation & Journalism |  
[##X] Fakes of Varying Shades: How Warning Affects Human Perception and Engagement Regarding LLM Hallucinations [[link]](https://arxiv.org/pdf/2404.03745)
[##X] Trust It or Not: Understanding Users' Motivations and Strategies for Assessing the Credibility of AI-Generated Information [[link]](https://journals.sagepub.com/doi/epub/10.1177/14614448241293154)
<font class='paper-index-title'> Optional: </font>
[##O] A New Era of AI-assisted Journalism at Bloomberg [[link]](https://onlinelibrary.wiley.com/doi/epdf/10.1002/aaai.12181)
[##O] News from Generative Artificial Intelligence Is Believed Less [[link]](https://dl.acm.org/doi/pdf/10.1145/3531146.3533077)
                       |       |

| 5    | 09/29/25 |   Human-AI Decision-Making I |     
[##X] Rethinking Human-AI Collaboration in Complex Medical Decision-Making: A Case Study in Sepsis Diagnosis [[link]](https://dl.acm.org/doi/pdf/10.1145/3613904.3642343)
[##X] Utilizing Human Behavior Modeling to Manipulate Explanations in AI-Assisted Decision-Making: The Good, the Bad, and the Scary [[link]](https://proceedings.neurips.cc/paper_files/paper/2024/file/08bd07d567d77d6dd8d82a4474706a5e-Paper-Conference.pdf)
<font class='paper-index-title'> Optional: </font> 
[##O] The Value of Information in Human-AI Decision-Making [[link]](https://arxiv.org/pdf/2502.06152)
|      |

|      | 10/01/25 |   [Project Discussion](https://docs.google.com/document/d/1rzq9ChQwoCX9Wwr71o06_mNkw58DyEqU3u6jZHFmk_s/edit?usp=sharing)   |    No presentation; Bring some project ideas and a pen/pencil                  |   P.1 due Sun |

| 6    | 10/06/25 |   Human-AI Decision-Making II   |   
[##X] Human-AI Collaboration: The Effect of AI Delegation on Human Task Performance and Task Satisfaction [[link]](https://dl.acm.org/doi/pdf/10.1145/3581641.3584052)
[##X] Trust Development and Repair in AI-Assisted Decision-Making during Complementary Expertise [[link]](https://dl.acm.org/doi/pdf/10.1145/3630106.3658924)
                     |    |

|      | 10/08/25 |   Interpretability & Explainability I    |     
[##X] Visual Analytics in Deep Learning: An Interrogative Survey for the Next Frontiers [[link]](https://arxiv.org/abs/1801.06889) <font class='paper-index-title'> (2-ok) </font> 
[##X] CNN Explainer: Learning Convolutional Neural Networks with Interactive Visualization [[link]](https://arxiv.org/abs/2004.15004)  
<font class='paper-index-title'> Optional: </font> 
[##O] Transformer Explainer [[link]](https://poloclub.github.io/transformer-explainer/)   
               |       |

| 7    | 10/13/25 |   Fall Break (no class)    |                     |       |

|      | 10/15/25 |    Interpretability & Explainability II  |      
[##X] Explanation, Prediction, and Causality: Three Sides of the Same Coin [[link]](https://osf.io/preprints/osf/u6vz5_v1)
[##X] The Mythos of Model Interpretability: In Machine Learning, the Concept of Interpretability Is Both Important and Slippery [[link]](https://dl.acm.org/doi/pdf/10.1145/3236386.3241340) 
                  |       |

| 8    | 10/20/25 |   Interpretability & Explainability III  |      
[##X] The Impact of Imperfect XAI on Human-AI Decision-Making [[link]](https://dl.acm.org/doi/pdf/10.1145/3641022) <font class='paper-index-title'> (2-ok) </font> 
[##X] “How Do I Fool You?": Manipulating User Trust via Misleading Black Box Explanation [[link]](https://trustml.github.io/docs/aies20.pdf) 
                  |       |

|      | 10/22/25 |   Trust & Reliance I    |              
[##X] How Explainability Contributes to Trust in AI [[link]](https://dl.acm.org/doi/pdf/10.1145/3531146.3533202)
[##X] Trust in AI-Assisted Decision-Making: Perspectives from Those Behind the System and Those for Whom the Decision Is Made [[link]](https://dl.acm.org/doi/pdf/10.1145/3613904.3642018)
<font class='paper-index-title'> Optional: </font>
[##O] Effect of Confidence and Explanation on Accuracy and Trust Calibration in AI-Assisted Decision-Making [[link]](https://dl.acm.org/doi/pdf/10.1145/3351095.3372852)
|       |

| 9    | 10/27/25 |   Trust & Reliance II   |   
[##X] Designing for Appropriate Reliance: The Roles of AI Uncertainty Presentation, Initial User Decision, and User Demographics in AI-Assisted Decision-Making [[link]](https://dl.acm.org/doi/pdf/10.1145/3637318) <font class='paper-index-title'> (2-ok) </font> 
[##X] It's Complicated: The Relationship Between User Trust, Model Accuracy, and Explanations in AI [[link]](https://dl.acm.org/doi/pdf/10.1145/3495013)
<font class='paper-index-title'> Optional: </font>
[##O] Exploring the Effects of Machine Learning Literacy Interventions on Laypeople's Reliance on Machine Learning Models [[link]](https://dl.acm.org/doi/pdf/10.1145/3490099.3511121)
|   Midterm out M due Sun    |

|      | 10/29/25 |   Trust in Generative AI    |       
[##X] In Generative AI We Trust: An Exploratory Study on Dimensionality and Structure of User Trust in ChatGPT [[link]](https://doi.org/10.1093/iwc/iwaf029)
[##X] Believing Anthropomorphism: Examining the Role of Anthropomorphic Cues on Trust in Large Language Models [[link]](https://dl.acm.org/doi/pdf/10.1145/3613905.3650818)
|      |

| 10   | 11/03/25 |  Uncertainty Visualization  |      
[##X] Why Authors Don't Visualize Uncertainty [[link]](https://mucollective.github.io/assets/papers/2019-value-of-uncertainty-vis.pdf)
[##X] ggdist: Visualizations of Distributions and Uncertainty in the Grammar of Graphics [[link]](https://mucollective.northwestern.edu/files/2023-ggdist.pdf)
                  |       |

|      | 11/05/25 |   Statistics & Probability     |    
[##X] Statistical Tests, P Values, Confidence Intervals, and Power: A Guide to Misinterpretations [[link]](https://link.springer.com/article/10.1007/s10654-016-0149-3)      
[##X] Fair Statistical Communication in HCI  [[link]](https://inria.hal.science/hal-01377894/file/fairstats-last.pdf) <font class='paper-index-title'> (2-ok) </font> 
<font class='paper-index-title'> Optional: </font>
[##O] Rethinking Statistical Analysis Methods for CHI  [[link]](https://judyrobertson.typepad.com/files/chi2012_submission_final.pdf)
|        |

| 11   | 11/10/25 |    Paper Writing & Swap  |  
Fumeng presents ~30 minutes <a href='/CMSC839E-2025/slides/review_n_revision.pdf' target='_blank'>[slides]</a> , ~45 minutes for paper swap and discussion.  [[instructions]](https://docs.google.com/document/d/19YIxeobhT7H3JKcHWBN9Q8KI3s55uz-X2KmVpNvUmUc/edit?usp=sharing)
|    P.2 due  AoE   |

|      | 11/12/25 |   Judgment & Decision      |   
[##X] Judgment and Decision Making [[link]](https://faculty.wharton.upenn.edu/wp-content/uploads/2015/07/1998---judgment-and-decision-making.pdf) <font class='paper-index-title'> (2-ok) </font> 
[##X] Decoupling Judgment and Decision Making: A Tale of Two Tails  [[link]](https://webspace.science.uu.nl/~telea001/uploads/PAPERS/TVCG24/paper.pdf)                  
|       |

| 12   | 11/17/25 |  Accountability & Governance    |    
[##X] How to Explain and Justify Almost Any Decision: Potential Pitfalls for Accountability in AI Decision-Making [[link]](https://dl.acm.org/doi/pdf/10.1145/3593013.3593972)
[##X] Reviewable Automated Decision-Making: A Framework for Accountable Algorithmic Systems [[link]](https://dl.acm.org/doi/pdf/10.1145/3442188.3445921)
                  |        |

|      | 11/19/25 |    Conflict & Tension    |      
[##X] The Conflict Between Explainable and Accountable Decision-Making Algorithms [[link]](https://facctconference.org/static/pdfs_2022/facct22-3534628.pdf)
[##X] AI in the Hands of Imperfect Users [[link]](https://www.nature.com/articles/s41746-022-00737-z)
|   |

| 13   | 11/24/25 |  Thanksgiving (no class)    |                        |    P.3 due AoE <br/>R.1 due AoE<br>     |

|      | 11/26/25 |  Thanksgiving (no class)       |                        |    R.2 out    |

| 14   | 12/01/25 |  Human-AI Interaction    |
[##X] Need Help? Designing Proactive AI Assistants for Programming [[link]](https://generativeaiandhci.github.io/papers/2025/genaichi2025_30.pdf)
[##X] Illuminating LLM Coding Agents: Visual Analytics for Deeper Understanding and Enhancement [[link]](https://arxiv.org/pdf/2508.12555)
                        |       |

|      | 12/03/25 | Bigger Thoughts   |     
[##X] How Artificial Intelligence Constrains Human Experience [[link]](https://www.journals.uchicago.edu/doi/pdf/10.1086/730709)
[##X] Participation in the Age of Foundation Models [[link]](https://emtseng.me/assets/Suresh-Tseng-Young-2024-FAccT_Participation-Foundation-Models.pdf)
|   R.2 due Sun AoE   |

| 15   | 12/08/25 | Final Paper Presentation      |                        |   Final out    |

|      | 12/10/25 | Final Paper Presentation     |                        |       |

| 16   | 12/15/25 |       |                       |   Revised paper due    |`




// "[##X] Rethinking the Ranks of Visual Channels  [[link]](https://arxiv.org/abs/2107.11367) [reviews] <br/> [##X] The Risks of Ranking: Revisiting Graphical Perception to Model Individual Differences in Visualization Performance  [[link]](https://mucollective.northwestern.edu/files/2022-perception-individual-differences.pdf)"
//  [##X] Graphical Perception: Theory, Experimentation, and Application to the Development of Graphical Method  [[link]](https://faculty.washington.edu/aragon/classes/hcde511/s12/readings/cleveland84.pdf) <br/>

export const collaboration_policy = `
<p> 
We encourage collaboration and discussion among students. However, solo assignments should be primarily completed on your own. You are welcome to seek help from the course staff during office hours or use Slack to ask questions and discuss with other students. For group projects, collaboration is encouraged on all aspects of the project and the paper.
</p>
`

export const late_policy = `
Overall, this course doesn’t have many assignments. To help guide our discussions, please submit your reading questions on time—they’re important for class prep. 

For assignments without a strict deadline, you can request a short extension if you let us know in advance. For assignments with hard deadlines (usually group submissions), please make sure your team submits on time. 

That said, we know life and deadlines (including conference ones!) can pile up. If multiple groups are affected, we’ll consider granting an extension.
</p>
`

export const ai_policy = ` <p>The scope of AI tools includes, but is not limited to, GPT, Claude, Gemini, DALL-E, Midjourney, and DeepSeek. In line with the spirit of this course

                    <ul>
                        <li>AI should <b>not</b> be used to <b>directly</b>  complete coursework. This includes, but is not limited to, summarizing papers without reading the original manuscripts or generating substantial portions of your assignments.</li>
                        <li>Clearly <b>mark</b> any content that is directly generated by AI. </li>
                        <li>Be mindful about your <b>reliance</b> on AI, especially in terms of <b>trusting</b> AI-generated content. </li>
                        <li>You may use AI to <b>assist</b> with coursework, such as inquiring about terms, brainstorming, and improving writing. </li>
                        <li>You are encouraged to use AI <b>creatively</b> and share your thoughts and experiences with us.</li>
                    </ul>
                </p>
`

export const support_text = `
We are committed to the full inclusion of all students. You should expect and demand respect from classmates and staff, and reciprocally, treat others with respect. If any incident challenges this commitment, please inform us immediately.

If you have a disability or condition that requires accommodations, please notify us early in the term. You can speak with us after class. For more information, contact Accessibility & Disability Services at (301) 314-7682 or adsfrontdesk@umd.edu.
`



export const acknowledgement = `
<p>The content of this class has been inspired by the classes and talks given by 
Jessica Hullman (<a href='https://www.mccormick.northwestern.edu/computer-science/academics/courses/descriptions/497-11.html'>COMP_SCI 497</a>) at Northwestern University, Matthew Kay (<a href='https://www.mccormick.northwestern.edu/computer-science/academics/courses/descriptions/496-24.html'>COMP_SCI 496</a>) at Northwestern University, 
David H. Laidlaw (<a href='https://cs.brown.edu/courses/csci2370/2022/'>CSCI2370</a>) at Brown University,
Jeff Huang (<a href='https://cs.brown.edu/courses/csci2300/'>CSCI2300</a>) at Brown University,
Yizheng Chen (<a href='https://surrealyz.github.io/classes/llmsec/llmsec.html'>CMSC818I</a>) at the University of Maryland, College Park, 
Arvind Satyanarayan (<a href='https://vis.csail.mit.edu/classes/6.859/'>6.859</a>) at MIT, Abhraneel Sarma and Maryam Hedayati (<a href='https://fumeng-yang.github.io/VIS23-Transparent-Research/'>Transparent Practices</a>) at Northwestern University, 
 Chat Wacharamanotham at the University of Zurich, and Pierre Dragicevic (<a href='https://www.aviz.fr/badstats'>Bad Stats</a>) at Inria, France.

`